import { useState, useRef } from 'react';

export const Collapsible = ({ number, title, content, color }) => {
    const [open, setOpen] = useState(false);
    const contentRef = useRef();

    const buttonClass = color + " mediumFont smallText";

    const toggle = () => {
        setOpen(!open);
    };

    return (
        <div className='collapsible'>
            <div onClick={toggle} className='collapsible-header'>
                <h2 className={buttonClass}>{title ? title : ""}</h2>
                <span className={`arrow ${color} ${open ? 'open' : ''}`}></span>
            </div>
            <div
                ref={contentRef}
                className='toggle'
                style={open ? { height: contentRef.current.scrollHeight + "px" } : { height: "0px" }}
            >
                <p className='lightFont smallText'>{content}</p>
            </div>
        </div>
    );
};